/* eslint-disable no-use-before-define no-unused-vars */

export const INIT_VALIDATION = "INIT_VALIDATION";
export const VALIDATION_SUCCESS = "VALIDATION_SUCCESS";
export const SEND_VALIDATION_EMAIL = "SEND_VALIDATION_EMAIL";

export function initValidation(serialNum) {
  return {
    type: INIT_VALIDATION,
    meta: {
      endpoint: "/installer/check/post?serial_number=" + serialNum,
      success: initValidationSuccess,
    },
  };
}

export function commission(serialNum) {
  return {
    type: SEND_VALIDATION_EMAIL,
    meta: {
      endpoint: "/installer/complete",
      method: "POST",
      body: {
        serialNum: serialNum,
      },
    },
  };
}

function initValidationSuccess(response) {
  console.log(response);
  const status = response.status;
  const allComponents = Object.values(response.aggregate);
  let phaseComponents;
  if ("undefined" === typeof response.phase) {
    phaseComponents = {};
  } else {
    phaseComponents = response.phase;
  }

  return {
    type: VALIDATION_SUCCESS,
    payload: {
      status,
      allComponents,
      phaseComponents,
    },
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/validation.js